export const isDisabled = (detail, captcha, cero) => {
  if (detail || cero) {
    return true;
  }
  if (captcha) {
    return false;
  }
  return true;
};
